customElements.define("sticky-component", class extends HTMLElement {
    connectedCallback(){
      this.stickyPoint = document.querySelector(this.dataset.stickyPoint) || null;
  
      if(!this.stickyPoint) return;

      console.log(' this.stickyPoint' ,  this.stickyPoint )
  
      window.addEventListener("load", ()=>{
        this.findPosition()
      })
  
      window.addEventListener("scroll", e=>{
        this.findPosition();
      })
  
    //   this.style.setProperty('--min-height', this.scrollHeight + 'px');
  
    //   window.addEventListener('resize', ()=>{
    //     this.style.setProperty('--min-height', this.scrollHeight + 'px');
    //   })
    }
  
    findPosition(){
      const {scrollY: windowTop} = window;
      const targetTop = this.stickyPoint.getBoundingClientRect().top + document.documentElement.scrollTop
  
      if(windowTop > targetTop && this.lastScroll <= targetTop){
        this.toggleWidget = true;
      }
      else if(windowTop < targetTop && this.lastScroll >= targetTop){
        this.toggleWidget = false;
      }
  
      this.lastScroll = windowTop;
    }
  
    set toggleWidget(boolean){
      boolean ? this.show() : this.close();
    }
  
    show(){
      //this.detectOtherSticky();
      this.classList.add('active');
      this.dataset.bodyClass && document.body.classList.add(this.dataset.bodyClass); 
    }
  
    close(){
      this.classList.remove('active');
      this.dataset.bodyClass && document.body.classList.remove(this.dataset.bodyClass);
    }
  
    detectOtherSticky(){
      const { inViewPort } = theme;
  
      const array = [];
      document.querySelectorAll('sticky-component').forEach(item=>{
        if(item != this){
          item.getStickyEl && array.push(item.getStickyEl);
        }
      });
  
  
      const headerSticky = document.querySelector('sticky-header');
      headerSticky && array.push(headerSticky);
  
      // this.bottom = 0;
  
      array.forEach(item=>{
        inViewPort(item, ()=>{
          const {bottom} = item.getBoundingClientRect();
          
          // this.bottom += bottom;
  
          // this.style.setProperty('--top', this.bottom+'px');
        }, true)
      })
    }
  
    get getStickyEl(){
      if(this.classList.contains('jsStickyEl'))
        return this;
  
      return this.querySelector('.jsStickyEl') || null;
    }
  });